module.exports = __webpack_public_path__ + "static/media/jcb.b2f476cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit-cards/jcb.png
// module id = 988
// module chunks = 0